import {thisIsAnApp} from "../variables/multiplatform";

// Fix WKWebView IOS bug where the view shifts about 80 pixels when an input is blurred
export const iosInputFix = () => {
    if(thisIsAnApp) {
        window.scrollTo(0, NaN);
    }
};